import { Action } from "../../../action";
import { DefaultApi } from "../../../api";
import { getCatchError } from "../../../getCatchError";
import { urls } from "../../../urls";

const setGetJackpotHistoryList = (params) => {
    return async (dispatch, getState) => {
        try {
            const { data } = await DefaultApi({
                params,
                method: 'get',
                url: urls.GET_LIST_HISTORY_JACKPOT
            });

            if (data.status === 'success') {
                dispatch(Action.SetGetJackpotHistoryListAction({
                    data: data.data,
                    countPage: data.countPage
                }));
            }

        } catch (error) {
            getCatchError(error)
        }
    }
}

export {
    setGetJackpotHistoryList as SetGetJackpotHistoryList
}